import { useMemo } from 'react';

/** Comparable form value: empty / null / undefined are the same, arrays compare by content */
const normalise = (value: unknown): unknown => {
  if (value === null || value === undefined) return '';
  if (Array.isArray(value)) return value.map(normalise);
  if (typeof value === 'object') {
    return Object.fromEntries(Object.keys(value as object).sort().map(k => [k, normalise((value as any)[k])]));
  }
  return typeof value === 'string' ? value.trim() : value;
};

/**
 * True when an edit form differs from what it started with — for disabling Save until there's
 * something to save. `initial` null = not loaded yet (no changes).
 */
export function useHasChanges<T>(current: T, initial: T | null): boolean {
  return useMemo(
    () => initial !== null && JSON.stringify(normalise(current)) !== JSON.stringify(normalise(initial)),
    [current, initial]
  );
}
